<template>
  <div>
    <div class="formsign" v-if="formsign && !showXuzhi">
      <!-- 选择报名表单弹窗 -->
      <div class="pagePopMask pFull" @click.self="closePop"></div>
      <div class="pagePop pCenter">
        <div class="w pad60">
          <div class="tit fnt_24">
            {{ Object.keys(personList).length > 0 ? '编辑' :  globalDataArray.siteTemplateLanguage.to_sign_up  }}
            <!--            <div
              class="xuzhiBtn"
              @click="targetXuzhi"
            >
              {{ globalDataArray.siteTemplateLanguage.join_notice }}
            </div>-->
          </div>

          <div class="cont">
            <div class="stform">
              <a-form :form="form" :model="data">
                <a-row :gutter="18">
                  <div v-for="item in columnList" :key="item.fieldSort + 'n'" v-if="item.isShow === '1' || item.isDoubleCheck">
                    <a-col :xs="24" :sm="24" :md="item.isStandalone === '0' ? 12 : 24" :lg="item.isStandalone === '0' ? 12 : 24" :xl="item.isStandalone === '0' ? 12 : 24">
                      <a-form-item
                        :label="item.fieldName" :extra="item.prompt && item.prompt[0] ? item.prompt[0] : ''"
                      >
                        <!--              普通输入框-->
                        <a-input
                          v-if="item.fieldType === 'text'"
                          v-decorator="[`data.${item.fieldCode}`, { rules: [{ required: item.verificationType , message: '请输入' + item.fieldName + '!' }] }]"
                        />
                        <!--              普通单选框-->
                        <a-radio-group
                          v-else-if="item.fieldType === 'radio' && item.fieldCode === 'teamType'"
                          @change="onChangeFieldType"
                          v-decorator="[`data.${item.fieldCode}`, { rules: [{ required: item.verificationType , message: '请选择' + item.fieldName + '!' }] }]"
                        >
                          <a-radio :value="ca.itemValue" v-for="(ca,index) in item.list" :key="ca.itemValue">
                            {{ ca.itemText }}
                            <a-tooltip placement="bottom">
                              <a-icon type="question-circle" title="" />
                              <template slot="title">
                                <span v-html="item.tipsmsg ? item.tipsmsg[index]?.content : ''"></span>
                              </template>
                            </a-tooltip>
                          </a-radio>
                        </a-radio-group>
                        <a-radio-group
                          v-else-if="item.fieldType === 'radio'"
                          v-decorator="[`data.${item.fieldCode}`, { rules: [{ required: item.verificationType , message: '请选择' + item.fieldName + '!' }] }]"
                        >
                          <a-radio :value="ca.itemValue" v-for="(ca,index) in item.list" :key="ca.itemValue">
                            {{ ca.itemText }}
                          </a-radio>
                        </a-radio-group>
                        <!--              下拉框-->
                        <a-select placeholder="请选择" v-else-if="item.fieldType === 'select'">
                          <a-select-option :value="po.itemValue" v-for="po in item.list" :key="po.itemValue">
                            {{ po.itemText }}
                          </a-select-option>
                        </a-select>
                        <!--              文件上传-->
                        <a-upload
                          v-else-if="item.fieldType === 'upload'"
                          v-decorator="[`data.${item.fieldCode}`,
                                        {
                                          getValueFromEvent: normFile,
                                          rules: [{ required: item.verificationType, message: '文件上传' }]
                                        }
                          ]"
                          name="file"
                          accept=".zip,.rar,.7z"
                          :file-list="item.fileList"
                          :remove="(file) => removeFiles1(file, item)"
                          :before-upload="(file) => beforeUpload1(file, item)"
                          :custom-request="customUpload"
                        >
                          <a-button :disabled="uploading" class="my-5">文件上传</a-button>
                        </a-upload>
                      </a-form-item>
                    </a-col>
                  </div>
                  <a-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                    <div class="line"></div>
                  </a-col>
                  <div v-for="item in showList" :key="item.fieldSort + 'n'" v-if="item.isShow === '1' || item.isDoubleCheck">
                    <a-col :xs="24" :sm="24" :md="item.isStandalone === '0' ? 12 : 24" :lg="item.isStandalone === '0' ? 12 : 24" :xl="item.isStandalone === '0' ? 12 : 24">
                      <a-form-item
                        :label="item.fieldName" :extra="item.prompt && item.prompt[0] ? item.prompt[0] : ''"
                      >
                        <!--              下拉框-->
                        <a-select
                          v-if="item.fieldCode === 'company' && item.isDoubleCheck"
                          show-search
                          allow-clear
                          :filter-option="false"
                          placeholder="请输入学校"
                          :get-popup-container="triggerNode => { return triggerNode.parentNode || document.body; }"
                          v-decorator="[`data.${item.fieldCode}`, { rules: [{ required: true, message: '请选择' + item.fieldName + '!' }] }]"
                          @search="searchCollege"
                        >
                          <a-select-option v-for="fi in filterdCollegeList" :key="fi.identificationCode" :value="fi.name">
                            {{ fi.name }}
                          </a-select-option>
                        </a-select>
                        <a-select
                          :label-in-value="true"
                          placeholder="请选择" v-else-if="item.fieldCode === 'countryCode'" @change="handleProvinceChange($event, '-1')"
                          v-decorator="[`data.${item.fieldCode}`, { rules: [{ required: item.verificationType, message: '请选择' + item.fieldName + '!' }] }]"
                        >
                          <a-select-option :value="po.parentId" v-for="po in item.list" :key="po.parentId">
                            {{ po.title }}
                          </a-select-option>
                        </a-select>
                        <a-select
                          :label-in-value="true"
                          placeholder="请选择" v-else-if="item.fieldCode === 'cityCode'"
                          v-decorator="[`data.${item.fieldCode}`, { rules: [{ required: item.verificationType, message: '请选择' + item.fieldName + '!' }] }]"
                        >
                          <a-select-option :value="po.itemValue" v-for="po in item.list" :key="po.itemValue">
                            {{ po.itemText }}
                          </a-select-option>
                        </a-select>
                        <a-select
                          placeholder="请选择" v-else-if="item.fieldType === 'select'"
                          v-decorator="[`data.${item.fieldCode}`, { rules: [{ required: item.verificationType, message: '请选择' + item.fieldName + '!' }] }]"
                        >
                          <a-select-option :value="po.itemValue" v-for="po in item.list" :key="po.itemValue">
                            {{ po.itemText }}
                          </a-select-option>
                        </a-select>
                        <!--              普通输入框-->
                        <a-input
                          v-else-if="item.fieldType === 'text' && item.verificationType === 'email'"
                          v-decorator="[`data.${item.fieldCode}`, { rules: [
                            { validator: validateNumber, trigger: 'blur' },
                            { required: item.verificationType , message: '请输入' + item.fieldName + '!' }] }]"
                        />
                        <a-input
                          v-else-if="item.fieldType === 'text' && item.verificationType === 'idCard'"
                          v-decorator="[`data.${item.fieldCode}`, { rules: [
                            { validator: validateID, trigger: 'blur' },
                            { required: item.verificationType , message: '请输入' + item.fieldName + '!' }] }]"
                        />
                        <a-input
                          v-else-if="item.fieldType === 'text' && item.verificationType === 'phone'"
                          v-decorator="[`data.${item.fieldCode}`, { rules: [
                            { pattern: /^[0-9-+]+$/, message: '请输入正确的手机号格式' },
                            { validator: verify.bootTwo ? (rule, value, callback) => validateTwoFactor(rule, value, callback, 'data.leaderName', 'data.userPhone') : undefined, trigger: 'blur' },
                            { required: item.verificationType , message: '请输入' + item.fieldName + '!' }] }]"
                        />
                        <a-input
                          v-else-if="item.fieldType === 'text'"
                          v-decorator="[`data.${item.fieldCode}`, { rules: [{ required: item.verificationType , message: '请输入' + item.fieldName + '!' }] }]"
                        />
                        <!--              普通单选框-->
                        <a-radio-group
                          v-else-if="item.fieldType === 'radio' && item.fieldCode === 'companyType'"
                          @change="onChangeCompany"
                          v-decorator="[`data.${item.fieldCode}`, { rules: [{ required: item.verificationType , message: '请选择' + item.fieldName + '!' }] }]"
                        >
                          <a-radio :value="ca.itemValue" v-for="(ca,index) in item.list" :key="ca.itemValue">
                            {{ ca.itemText }}
                          </a-radio>
                        </a-radio-group>
                        <a-radio-group
                          v-else-if="item.fieldType === 'radio'"
                          v-decorator="[`data.${item.fieldCode}`, { rules: [{ required: item.verificationType , message: '请选择' + item.fieldName + '!' }] }]"
                        >
                          <a-radio :value="ca.itemValue" v-for="(ca,index) in item.list" :key="ca.itemValue">
                            {{ ca.itemText }}
                          </a-radio>
                        </a-radio-group>
                        <!--              文件上传-->
                        <a-upload
                          v-else-if="item.fieldType === 'upload'"
                          v-decorator="[`data.${item.fieldCode}`,
                                        {
                                          getValueFromEvent: normFile,
                                          rules: [{ required: item.verificationType, message: '文件上传' }]
                                        }
                          ]"
                          name="file"
                          accept=".zip,.rar,.7z"
                          :file-list="item.fileList"
                          :remove="(file) => removeFiles1(file, item)"
                          :before-upload="(file) => beforeUpload1(file, item)"
                          :custom-request="customUpload"
                        >
                          <a-button :disabled="uploading" class="my-5">文件上传</a-button>
                        </a-upload>
                      </a-form-item>
                    </a-col>
                  </div>
                </a-row>

                <!--
                <a-form-item :label="globalDataArray.siteTemplateLanguage.team_name">
                  <a-input
                    v-decorator="['data.teamName', { rules: [{ required: true, message: globalDataArray.siteTemplateLanguage.enter_join_team }] }]"
                  />
                </a-form-item>

                <a-form-item :label="globalDataArray.siteTemplateLanguage.team_type">
                  <a-radio-group
                    @change="onChangeTeamType"
                    v-decorator="['data.teamType', { rules: [{ required: true, message: globalDataArray.siteTemplateLanguage.select_team_type }] }]"
                  >
                    <span class="radioLabelBox" v-for="(item, index) in teamList" :key="index">
                      <a-radio :style="radioStyle" :value="item.itemValue">{{ item.itemText }}</a-radio>
                      <a-tooltip placement="bottom">
                        <a-icon type="question-circle" title="" />
                        <template slot="title">
                          <span v-html="item.tipsmsg"></span>
                        </template>
                      </a-tooltip>
                    </span>
                  </a-radio-group>
                </a-form-item>

                <a-form-item :label="globalDataArray.siteTemplateLanguage.instructor">
                  <a-input v-decorator="['data.instructor']" />
                </a-form-item>

                <a-form-item :label="globalDataArray.siteTemplateLanguage.sign_upload_file_label" :extra="globalDataArray.siteTemplateLanguage.sign_upload_file_tips" v-if="teamType === '02'">
                  <a-upload
                    v-decorator="[
                      'data.fileUrl',
                      {
                        getValueFromEvent: normFile,
                        rules: [{ required: true, message: globalDataArray.siteTemplateLanguage.select_file_url }]
                      }
                    ]"
                    name="file"
                    accept=".zip,.rar,.7z"
                    :file-list="fileList"
                    :remove="removeFiles"
                    :before-upload="beforeUpload"
                    :custom-request="customUpload"
                  >
                    <a-button :disabled="uploading" class="my-5">{{ globalDataArray.siteTemplateLanguage.sign_upload_file_button }}</a-button>
                  </a-upload>
                  <div class="ant-form-extra" v-if="globalDataArray.siteTemplateLanguage.sign_upload_file_template" v-html="globalDataArray.siteTemplateLanguage.sign_upload_file_template"></div>
                </a-form-item>

                <div class="line"></div>

                <div class="item" v-if="curInfoArray.currentLanguge != 'zh_CN' && curInfoArray.currentLanguge != ''">
                  <a-form-item :label="globalDataArray.siteTemplateLanguage.team_leader">
                    <a-input
                      v-decorator="['data.userName', { rules: [{ required: true, message: globalDataArray.siteTemplateLanguage.enter_captain_name }] }]"
                    />
                  </a-form-item>
                  <a-form-item :label="globalDataArray.siteTemplateLanguage.team_user_email">
                    <a-input
                      v-decorator="['data.userMail', { rules: [{ validator: validateNumber, trigger: 'blur' }, { required: true, message: globalDataArray.siteTemplateLanguage.person_please_form_user_email }] }]"
                    />
                  </a-form-item>
                </div>

                <div class="item" v-if="curInfoArray.currentLanguge == 'zh_CN' || curInfoArray.currentLanguge == ''">
                  <a-form-item :label="globalDataArray.siteTemplateLanguage.team_leader">
                    <a-input
                      v-decorator="['data.userName', { rules: [{ required: true, message: globalDataArray.siteTemplateLanguage.enter_captain_name }] }]"
                    />
                  </a-form-item>
                  <a-form-item :label="globalDataArray.siteTemplateLanguage.team_user_phone">
                    <a-input
                      v-decorator="['data.userPhone', { rules: [{ pattern: /^[0-9-+]+$/, message: globalDataArray.siteTemplateLanguage.tel_format_error }, { required: true, message: globalDataArray.siteTemplateLanguage.enter_member_tel }] }]"
                    />
                  </a-form-item>
                </div>
                <div class="item" v-if="curInfoArray.currentLanguge == 'zh_CN' || curInfoArray.currentLanguge == ''">
                  <a-form-item :label="globalDataArray.siteTemplateLanguage.team_user_email">
                    <a-input
                      v-decorator="['data.userMail', { rules: [{ validator: validateNumber, trigger: 'blur' }, { required: true, message: globalDataArray.siteTemplateLanguage.person_please_form_user_email }] }]"
                    />
                  </a-form-item>
                  <a-form-item :label="globalDataArray.siteTemplateLanguage.team_user_company_type">
                    <a-radio-group
                      @change="onChangeCompanyType"
                      v-decorator="['data.companyType', { rules: [{ required: true, message: globalDataArray.siteTemplateLanguage.person_please_form_company_type }] }]"
                    >
                      <a-radio
                        :style="radioStyle" v-for="(item, index) in companyList" :value="item.itemValue"
                        :key="index"
                      >
                        {{ item.itemText }}
                      </a-radio>
                    </a-radio-group>
                  </a-form-item>
                </div>

                <a-form-item
                  :label="globalDataArray.siteTemplateLanguage.enter_dw_name"
                  v-if="form.getFieldValue('data.companyType') && (curInfoArray.currentLanguge == 'zh_CN' || curInfoArray.currentLanguge == '')"
                >
                  <a-select
                    show-search
                    allow-clear
                    :filter-option="false"
                    :placeholder="globalDataArray.siteTemplateLanguage.search_keywords"
                    :get-popup-container="triggerNode => { return triggerNode.parentNode || document.body; }"
                    v-decorator="['data.company', { rules: [{ required: true, message: globalDataArray.siteTemplateLanguage.person_please_form_company_name }] }]"
                    @search="searchCollege"
                    v-if="form.getFieldValue('data.companyType') === '02'"
                  >
                    <a-select-option v-for="item in filterdCollegeList" :key="item.identificationCode" :value="item.name">
                      {{ item.name }}
                    </a-select-option>
                  </a-select>
                  <a-input
                    v-decorator="['data.company', { rules: [{ required: true, message: globalDataArray.siteTemplateLanguage.person_please_form_company_name }] }]"
                    v-else
                  />
                </a-form-item>

                <a-form-item
                  :label="globalDataArray.siteTemplateLanguage.team_user_job_type"
                  v-if="curInfoArray.currentLanguge == 'zh_CN' || curInfoArray.currentLanguge == ''"
                >
                  <a-radio-group @change="onChange" v-decorator="['data.jobType']">
                    <a-radio
                      :style="radioStyle" v-for="(item, index) in jobList" :value="item.itemValue"
                      :key="index"
                    >
                      {{ item.itemText }}
                    </a-radio>
                  </a-radio-group>
                </a-form-item>

                <div class="item">
                  <a-form-item :label="globalDataArray.siteTemplateLanguage.person_form_province">
                    &lt;!&ndash; <a-cascader :options="cityList" :defaultValue="defaultArea" placeholder="Please select" @change="onChange" /> &ndash;&gt;
                    <a-select
                      :get-popup-container="triggerNode => { return triggerNode.parentNode || document.body; }"
                      @change="handleProvinceChange($event, '-1')" :label-in-value="true"
                      v-decorator="['data.countryCode', { rules: [{ required: true, message: globalDataArray.siteTemplateLanguage.person_please_form_province }] }]"
                    >
                      <a-select-option v-for="item in provinceList" :key="item.parentId">
                        {{ item.title }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>

                  <a-form-item :label="globalDataArray.siteTemplateLanguage.team_user_city">
                    <a-select
                      :get-popup-container="triggerNode => { return triggerNode.parentNode || document.body; }"
                      :label-in-value="true" v-decorator="['data.cityCode']"
                    >
                      <a-select-option v-for="i in data.cityList" :key="i.parentId">
                        {{ i.title }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </div>
-->

                <!-- 增减团队成员模板 start -->
                <a-row :gutter="18">
                  <div class="addPrsonTemp" v-for="(k) in form.getFieldValue('keys')" :key="k">
                    <a-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                      <div class="line"></div>
                    </a-col>
                    <div v-for="item in temp[k].columnList" :key="item.fieldSort + 'n'" v-if="item.isShow === '1' || item.isDoubleCheck">
                      <a-col :xs="24" :sm="24" :md="item.isStandalone === '0' ? 12 : 24" :lg="item.isStandalone === '0' ? 12 : 24" :xl="item.isStandalone === '0' ? 12 : 24">
                        <a-form-item
                          :label="item.fieldName" :extra="item.prompt && item.prompt[0] ? item.prompt[0] : ''"
                        >
                          <!--              下拉框-->
                          <a-select
                            v-if="item.fieldCode === 'company' && item.isDoubleCheck"
                            show-search
                            allow-clear
                            :filter-option="false"
                            placeholder="请输入学校"
                            :get-popup-container="triggerNode => { return triggerNode.parentNode || document.body; }"
                            v-decorator="[`temp[${k}].${item.fieldCode}`, { rules: [{ required: true, message: '请选择' + item.fieldName + '!' }] }]"
                            @search="(value) => searchCollege1(value, k)"
                          >
                            <a-select-option v-for="fi in temp[k].filterdCollegeList" :key="fi.identificationCode" :value="fi.name">
                              {{ fi.name }}
                            </a-select-option>
                          </a-select>
                          <a-select
                            :label-in-value="true"
                            placeholder="请选择" v-else-if="item.fieldCode === 'countryCode'" @change="handleProvinceChange($event, k)"
                            v-decorator="[`temp[${k}].${item.fieldCode}`, { rules: [{ required: item.verificationType, message: '请选择' + item.fieldName + '!' }] }]"
                          >
                            <a-select-option :value="po.parentId" v-for="po in item.list" :key="po.parentId">
                              {{ po.title }}
                            </a-select-option>
                          </a-select>
                          <a-select
                            :label-in-value="true"
                            placeholder="请选择" v-else-if="item.fieldCode === 'cityCode'"
                            v-decorator="[`temp[${k}].${item.fieldCode}`, { rules: [{ required: item.verificationType, message: '请选择' + item.fieldName + '!' }] }]"
                          >
                            <a-select-option :value="po.itemValue" v-for="po in item.list" :key="po.itemValue">
                              {{ po.itemText }}
                            </a-select-option>
                          </a-select>
                          <a-select
                            placeholder="请选择" v-else-if="item.fieldType === 'select'"
                            v-decorator="[`temp[${k}].${item.fieldCode}`, { rules: [{ required: item.verificationType, message: '请选择' + item.fieldName + '!' }] }]"
                          >
                            <a-select-option :value="po.itemValue" v-for="po in item.list" :key="po.itemValue">
                              {{ po.itemText }}
                            </a-select-option>
                          </a-select>
                          <!--              普通输入框-->
                          <a-input
                            v-else-if="item.fieldType === 'text' && item.verificationType === 'email'"
                            v-decorator="[`temp[${k}].${item.fieldCode}`, { rules: [
                              { validator: validateNumber, trigger: 'blur' },
                              { required: item.verificationType , message: '请输入' + item.fieldName + '!' }] }]"
                          />
                          <a-input
                            v-else-if="item.fieldType === 'text' && item.verificationType === 'idCard'"
                            v-decorator="[`temp[${k}].${item.fieldCode}`, { rules: [
                              { validator: validateID, trigger: 'blur' },
                              { required: item.verificationType , message: '请输入' + item.fieldName + '!' }] }]"
                          />
                          <a-input
                            v-else-if="item.fieldType === 'text' && item.verificationType === 'phone'"
                            v-decorator="[`temp[${k}].${item.fieldCode}`, { rules: [
                              { pattern: /^[0-9-+]+$/, message: '请输入正确的手机号格式' },
                              { validator: verify.bootTwo ? (rule, value, callback) => validateTwoFactor(rule, value, callback, `temp[${k}].userName`, `temp[${k}].userPhone`) : undefined, trigger: 'blur' },
                              { required: item.verificationType , message: '请输入' + item.fieldName + '!' }] }]"
                          />
                          <a-input
                            v-else-if="item.fieldType === 'text'"
                            v-decorator="[`temp[${k}].${item.fieldCode}`, { rules: [{ required: item.verificationType , message: '请输入' + item.fieldName + '!' }] }]"
                          />
                          <!--              普通单选框-->
                          <a-radio-group
                            v-else-if="item.fieldType === 'radio' && item.fieldCode === 'companyType'"
                            @change="(e) => onChangeCompany1(e, k)"
                            v-decorator="[`temp[${k}].${item.fieldCode}`, { rules: [{ required: item.verificationType , message: '请选择' + item.fieldName + '!' }] }]"
                          >
                            <a-radio :value="ca.itemValue" v-for="(ca,index) in item.list" :key="ca.itemValue">
                              {{ ca.itemText }}
                            </a-radio>
                          </a-radio-group>
                          <a-radio-group
                            v-else-if="item.fieldType === 'radio'"
                            v-decorator="[`temp[${k}].${item.fieldCode}`, { rules: [{ required: item.verificationType , message: '请选择' + item.fieldName + '!' }] }]"
                          >
                            <a-radio :value="ca.itemValue" v-for="(ca,index) in item.list" :key="ca.itemValue">
                              {{ ca.itemText }}
                            </a-radio>
                          </a-radio-group>
                          <!--              文件上传-->
                          <a-upload
                            v-else-if="item.fieldType === 'upload'"
                            v-decorator="[`temp[${k}].${item.fieldCode}`,
                                          {
                                            getValueFromEvent: normFile,
                                            rules: [{ required: item.verificationType, message: '文件上传' }]
                                          }
                            ]"
                            name="file"
                            accept=".zip,.rar,.7z"
                            :file-list="item.fileList"
                            :remove="(file) => removeFiles1(file, item)"
                            :before-upload="(file) => beforeUpload1(file, item)"
                            :custom-request="customUpload"
                          >
                            <a-button :disabled="uploading" class="my-5 upload_new">文件上传</a-button>
                          </a-upload>
                        </a-form-item>
                      </a-col>
                    </div>
                    <a-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                      <a-button @click="delPerson(k)">
                        <a-icon type="minus" />
                        {{ globalDataArray.siteTemplateLanguage.del_team_member }}
                      </a-button>
                    </a-col>
                    <!--
                    <div class="item" v-if="curInfoArray.currentLanguge != 'zh_CN' && curInfoArray.currentLanguge != ''">
                      <a-form-item :label="globalDataArray.siteTemplateLanguage.team_member_name">
                        <a-input
                          v-decorator="[`temp[${k}].userName`, { rules: [{ required: true, message: globalDataArray.siteTemplateLanguage.person_form_please_user_name }] }]"
                        />
                      </a-form-item>
                      <a-form-item :label="globalDataArray.siteTemplateLanguage.team_user_email">
                        <a-input
                          v-decorator="[`temp[${k}].userMail`, { rules: [{ validator: validateNumber, trigger: 'blur' }, { required: true, message: globalDataArray.siteTemplateLanguage.person_please_form_user_email }] }]"
                        />
                      </a-form-item>
                    </div>

                    <div class="item" v-if="curInfoArray.currentLanguge == 'zh_CN' || curInfoArray.currentLanguge == ''">
                      <a-form-item :label="globalDataArray.siteTemplateLanguage.team_member_name">
                        <a-input
                          v-decorator="[`temp[${k}].userName`, { rules: [{ required: true, message: globalDataArray.siteTemplateLanguage.person_form_please_user_name }] }]"
                        />
                      </a-form-item>
                      <a-form-item :label="globalDataArray.siteTemplateLanguage.team_user_phone">
                        <a-input
                          v-decorator="[`temp[${k}].userPhone`, { rules: [{ pattern: /^[0-9-+]+$/, message: globalDataArray.siteTemplateLanguage.tel_format_error }, { required: true, message: globalDataArray.siteTemplateLanguage.enter_member_tel }] }]"
                        />
                      </a-form-item>
                    </div>

                    <div class="item" v-if="curInfoArray.currentLanguge == 'zh_CN' || curInfoArray.currentLanguge == ''">
                      <a-form-item :label="globalDataArray.siteTemplateLanguage.team_user_email">
                        <a-input
                          v-decorator="[`temp[${k}].userMail`, { rules: [{ validator: validateNumber, trigger: 'blur' }, { required: true, message: globalDataArray.siteTemplateLanguage.person_please_form_user_email }] }]"
                        />
                      </a-form-item>
                      <a-form-item :label="globalDataArray.siteTemplateLanguage.team_user_company_type">
                        <a-radio-group
                          @change="onChangeCompanyTypeForTeam(k)"
                          v-decorator="[`temp[${k}].companyType`, { rules: [{ required: true, message: globalDataArray.siteTemplateLanguage.person_please_form_company_type }] }]"
                        >
                          <a-radio
                            :style="radioStyle" v-for="(item, index1) in companyList" :value="item.itemValue"
                            :key="index1"
                          >
                            {{ item.itemText }}
                          </a-radio>
                        </a-radio-group>
                      </a-form-item>
                    </div>

                    <a-form-item
                      :label="globalDataArray.siteTemplateLanguage.enter_dw_name"
                      v-if="form.getFieldValue(`temp[${k}].companyType`) && (curInfoArray.currentLanguge == 'zh_CN' || curInfoArray.currentLanguge == '')"
                    >
                      <a-select
                        show-search
                        allow-clear
                        :filter-option="false"
                        :placeholder="globalDataArray.siteTemplateLanguage.search_keywords"
                        :get-popup-container="triggerNode => { return triggerNode.parentNode || document.body; }"
                        v-decorator="[`temp[${k}].company`, { rules: [{ required: true, message: globalDataArray.siteTemplateLanguage.person_please_form_company_name }] }]"
                        @search="searchCollege"
                        v-if="form.getFieldValue(`temp[${k}].companyType`) === '02'"
                      >
                        <a-select-option v-for="item in filterdCollegeList" :key="item.identificationCode" :value="item.name">
                          {{ item.name }}
                        </a-select-option>
                      </a-select>
                      <a-input
                        v-decorator="[`temp[${k}].company`, { rules: [{ required: true, message: globalDataArray.siteTemplateLanguage.person_please_form_company_name }] }]"
                        v-else
                      />
                    </a-form-item>

                    <a-form-item
                      :label="globalDataArray.siteTemplateLanguage.team_user_job_type"
                      v-if="curInfoArray.currentLanguge == 'zh_CN' || curInfoArray.currentLanguge == ''"
                    >
                      <a-radio-group @change="onChange" v-decorator="[`temp[${k}].jobType`]">
                        <a-radio
                          :style="radioStyle" v-for="(item, index1) in jobList" :value="item.itemValue"
                          :key="index1"
                        >
                          {{ item.itemText }}
                        </a-radio>
                      </a-radio-group>
                    </a-form-item>

                    <div class="item">
                      <a-form-item :label="globalDataArray.siteTemplateLanguage.person_form_province">
                        <a-select
                          :get-popup-container="triggerNode => { return triggerNode.parentNode || document.body; }"
                          @change="handleProvinceChange($event, k)" :label-in-value="true"
                          v-decorator="[`temp[${k}].countryCode`, { rules: [{ required: true, message: globalDataArray.siteTemplateLanguage.person_please_form_province }] }]"
                        >
                          <a-select-option v-for="prov in provinceList" :key="prov.parentId">
                            {{ prov.title }}
                          </a-select-option>
                        </a-select>
                      </a-form-item>

                      <a-form-item :label="globalDataArray.siteTemplateLanguage.team_user_city">
                        <a-select
                          :get-popup-container="triggerNode => { return triggerNode.parentNode || document.body; }"
                          :label-in-value="true" v-decorator="[`temp[${k}].cityCode`]"
                        >
                          <a-select-option v-for="city in temp[k].cityList" :key="city.parentId">
                            {{ city.title }}
                          </a-select-option>
                        </a-select>
                      </a-form-item>
                    </div>-->
                  </div>
                </a-row>

                <a-button @click="addPerson()">
                  <a-icon type="plus" />
                  {{ globalDataArray.siteTemplateLanguage.add_team_member }}
                </a-button>
                <!-- 增减团队成员模板 end -->
              </a-form>
            </div>
          </div>

          <div class="btnBox fnt_18">
            <div class="btn btn1" @click="btnClick('1')">{{ Object.keys(personList).length > 0 ? '确定' :  globalDataArray.siteTemplateLanguage.right_away_sign  }}</div>
            <div class="btn btn2" @click="btnClick('2')">{{ globalDataArray.siteTemplateLanguage.cancel }}</div>
          </div>

          <div class="close" @click.self="closePop"></div>
        </div>
      </div>
    </div>

    <div class="pagePopMask pFull" v-if="showXuzhi" @click="targetXuzhi"></div>
    <div class="pagePop pCenter" v-if="showXuzhi">
      <div class="w pad60">
        <div class="tit fnt_32">{{ xuzhiCont.title }}</div>

        <div class="cont" v-html="xuzhiCont.content">
        </div>
        <div class="btnBox fnt_18">
          <div class="btn btn1" @click="targetXuzhi">{{ globalDataArray.siteTemplateLanguage.verify }}</div>
        </div>
        <div class="close" @click="targetXuzhi"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { message } from 'ant-design-vue'
import debounce from 'lodash/debounce'
import { getCompetitionDict, getProvinceList, getCityList, getArticle, getArticleDetail } from '@/api/api'
import { competitionSub, uploadFile, getCollegeList, queryByParentId, boolAuth, verifyTwo } from '@/api/saiti'

let id = 0

export default {
  name: 'Formsign',
  props: {
    formsign: {
      type: Boolean,
      default: false
    },
    curInfoArray: {
      type: Object,
      default: () => ({})
    },
    competitionId: {
      type: String,
      default: ''
    },
    inviteId: {
      type: String,
      default: ''
    },
    personList: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    this.searchCollege = debounce(this.searchCollege, 800)
    this.searchCollege1 = debounce(this.searchCollege1, 800)

    return {
      subSignInfo: true,
      data: {
        teamName: '',
        teamType: '',
        leaderName: '',
        userName: '',
        userPhone: '',
        userMail: '',
        companyType: '',
        company: '',
        jobType: '',
        countryCode: '',
        countryName: '',
        cityCode: '',
        cityName: '',
        cityList: [],
        temp: [],
        fileUrl: ''
      },

      temp: [], // 添加的队员数据模板

      radioStyle: {
        display: 'block',
        height: '30px',
        lineHeight: '30px'
      },
      // form: this.$form.createForm(this, { name: 'dynamic_rule' }),
      provinceList: {}, // 公共的省或国家
      companyList: {}, // 公共的单位类型
      jobList: {}, // 公共的职业类型
      teamList: {}, // 公共的团队类型
      cityList: {},
      xuzhiCont: '',
      showXuzhi: false,
      uploading: false,
      teamType: '',
      fileList: [],
      collegeList: [],
      filterdCollegeList: [],
      columnList: [], // 团队信息字段列表
      showList: [], // 队长固定列表
      teamMemberList: [], // 队员固定列表
      allList: [], // 字段所有信息
      dictCodeArray: [], // 列表字典值
      verify: {}, // 验证要素
      editPersonInfo: {} // 编辑队员信息
    }
  },

  beforeCreate() {
    this.form = this.$form.createForm(this, { name: 'dynamic_form_item' })
    this.form.getFieldDecorator('keys', { initialValue: [], preserve: true })
  },

  mounted() {
    console.log('personList_mount', this.personList)
    this.getCollegeList()
  },

  watch: {
    formsign: {
      immediate: true,
      async handler(val) {
        if (val) {
          const that = this
          that.temp = []
          this.subSignInfo = true
          this.xuzhiCont = ''
          this.teamType = ''
          this.fileList = []
          id = 0
          this.form.resetFields()
          await this.initDictFun()
          console.log(structuredClone(this.personList), 'personList')
          this.editPersonInfo = structuredClone(this.personList)
          if (this.personList && Object.keys(this.personList).length !== 0) {
            const formValues = {}
            Object.keys(this.editPersonInfo).forEach(key => {
              formValues[`data.${key}`] = this.editPersonInfo[key]
            })
            const ccCode = {
              key: this.editPersonInfo.countryCode,
              label: this.editPersonInfo.countryName
            }
            let ctCode = ''
            if (this.editPersonInfo.cityCode) {
              ctCode = {
                key: this.editPersonInfo.cityCode,
                label: this.editPersonInfo.cityName
              }
            }
            formValues['data.countryCode'] = ccCode
            formValues['data.cityCode'] = ctCode
            this.form.setFieldsValue(formValues)
            this.data = this.editPersonInfo
            console.log(this.data, 'data')
          }
        }
      }
    }
    // personList: {
    //   handler(newVal) {
    //     if (newVal && Object.keys(newVal).length !== 0) {
    //       this.$nextTick(() => {
    //         const formValues = {}
    //         Object.keys(newVal).forEach(key => {
    //           formValues[`data.${key}`] = newVal[key]
    //         })
    //         const ccCode = {
    //           key: newVal.countryCode,
    //           label: newVal.countryName
    //         }
    //         let ctCode = ''
    //         if (newVal.cityCode) {
    //           ctCode = {
    //             key: newVal.cityCode,
    //             label: newVal.cityName
    //           }
    //         }
    //         formValues['data.countryCode'] = ccCode
    //         formValues['data.cityCode'] = ctCode
    //         this.form.setFieldsValue(formValues)
    //       })
    //     }
    //   },
    //   immediate: true, // 立即执行一次
    //   deep: true // 深度监听对象变化
    // }
  },

  methods: {
    async initDictFun() {
      const res = await getProvinceList()
      if (res.success) {
        this.provinceList = res.result // 省或国家列表
      }
      // 获取报名模板
      await this.findAllColunm()
      // 获取是否开启验证
      const params = 'language=' + this.globalDataArray.siteInfo.language + '&competitionId=' + this.curInfoArray.competitionId
      const boolAuthRes = await boolAuth(params)
      if (boolAuthRes.success) {
        this.verify = boolAuthRes.result
      }
    },

    async findAllColunm() {
      const paTemp = 'language=' + this.globalDataArray.siteInfo.language + '&templateId=' + this.curInfoArray.templateId
      const res = await queryByParentId(paTemp)
      if (res.success) {
        // 全部字段信息
        this.allList = JSON.parse(res.result.fieldJson)
        // 获取所有字典值
        this.allList.forEach(item => {
          // 检查 item 中是否有 dictCode 属性
          if (item.dictCode) {
            // 将 dictCode 数据添加到数组中
            this.dictCodeArray.push(item.dictCode)
          }
        })
        await this.findDictCode()
      }
    },

    // 给字段值绑定字典列表
    async findDictCode() {
      const param = 'dictCode=' + this.dictCodeArray.join(',')
      const res = await getCompetitionDict(param)
      if (res.success) {
        const dictCodeList = res.result
        this.allList = this.allList.map(showItem => {
          const dictItem = dictCodeList.find(dictItem => dictItem.dictCode === showItem.dictCode)
          if (dictItem) {
            showItem.list = dictItem.list
          }
          if (showItem.fieldType === 'upload') {
            showItem.fileList = []
          }
          if (showItem.fieldCode === 'countryCode') {
            showItem.list = this.provinceList
            console.log(showItem, this.provinceList)
          }
          return showItem
        })
        this.columnList = this.allList.filter(item => item.isTeam === 1)
        this.showList = this.allList.filter(item => item.isTeam === 0)
        const teamMemberListCopy = JSON.parse(JSON.stringify(this.showList))
        teamMemberListCopy.forEach(item => {
          if (item.fieldCode === 'leaderName') {
            item.fieldName = '队员'
            item.fieldCode = 'userName'
          }
        })
        this.teamMemberList = teamMemberListCopy
        console.log(this.columnList, 'lllll')
        console.log(this.showList, 'mmmmmm')
        console.log(this.teamMemberList, 'zzzzz')
      }
    },

    onChange(e) {
      // console.log(e.target.value)
    },

    addPerson() {
      const curInfoArray = this.curInfoArray
      const max_member_num = this.globalDataArray.siteTemplateLanguage.max_member_num
      const data = structuredClone(this.data)
      const { form } = this
      // can use data-binding to get
      const keys = form.getFieldValue('keys')
      if (keys.length == curInfoArray.teamsUsers - 1) {
        message.error(max_member_num + curInfoArray.teamsUsers)
        return false
      }
      data.columnList = structuredClone(this.teamMemberList)
      data.filterdCollegeList = []
      this.temp.push(data)

      const nextKeys = keys.concat(id++)

      // can use data-binding to set
      // important! notify form to detect changes
      form.setFieldsValue({
        keys: nextKeys
      })
    },
    delPerson(k) {
      // this.temp.splice(k,1)

      const { form } = this
      // can use data-binding to get
      const keys = form.getFieldValue('keys')

      // can use data-binding to set
      form.setFieldsValue({
        keys: keys.filter(key => key !== k)
      })
    },

    // 省市联动
    handleProvinceChange(e, ind) {
      console.log(e, ind)
      const that = this
      const params = 'pid=' + e.key + '&language=' + this.globalDataArray.siteInfo.language
      getCityList(params).then(res => {
        if (res.success) {
          if (ind === '-1') {
            this.showList.forEach(item => {
              if (item.fieldCode === 'cityCode') {
                res.result.forEach(ca => {
                  ca.itemValue = ca.id
                  ca.itemText = ca.title
                })
                item.list = res.result
              }
            })
            setTimeout(() => {
              // 选择后清空二级
              this.form.setFieldsValue({
                'data.cityCode': ''
              })
            })
          } else {
            that.temp[ind].columnList.forEach(item => {
              if (item.fieldCode === 'cityCode') {
                res.result.forEach(ca => {
                  ca.itemValue = ca.id
                  ca.itemText = ca.title
                })
                item.list = res.result
              }
            })
            setTimeout(() => {
              // 选择后清空二级
              this.form.setFieldsValue({
                [`temp[${ind}].cityCode`]: ''
              })
            })
          }
        }
      })
    },
    handleProvinceChange1(e) {
      console.log(e)
      const that = this
      const params = 'pid=' + e + '&language=' + this.globalDataArray.siteInfo.language
      getCityList(params).then(res => {
        if (res.success) {
          that.showList.forEach(item => {
            if (item.fieldCode === 'city_code') {
              item.cityList = res.result
            }
          })
          setTimeout(() => {
            // 选择后清空二级
            this.form.setFieldsValue({
              'data.city_code': ''
            })
          })
        }
      })
    },

    btnClick(num) {
      if (num === '1') { // 报名
        if (this.subSignInfo) {
          // eslint-disable-next-line
          console.log("1@@@@@@@@@@@@@@@id: ", this.competitionId)
          // eslint-disable-next-line
          console.log("2@@@@@@@@@@@@@@@id: ", this.inviteId)

          const sourceParam = (window.localStorage.getItem('competition-utm-source') || '').trim()

          this.form.validateFields((err, val) => {
            console.log(val, 'llllll')
            const params = []
            const curInfoArray = this.curInfoArray
            Object.keys(curInfoArray).forEach(key => {
              if (val.data[key] === undefined || val.data[key] === null) {
                val.data[key] = curInfoArray[key]
              }
            })
            val.data['isCaptain'] = 1
            val.data['leaderName'] = val.data['leaderName']
            val.data['userName'] = val.data['leaderName']

            if (val.data.countryCode) {
              const countryKL = val.data.countryCode
              val.data['countryCode'] = countryKL.key
              val.data['countryName'] = countryKL.label
            }

            if (val.data.cityCode) {
              const cityKL = val.data.cityCode
              val.data['cityCode'] = cityKL.key
              val.data['cityName'] = cityKL.label
            } else {
              val.data['cityCode'] = ''
              val.data['cityName'] = ''
            }

            if (sourceParam) {
              val.data['inviteCode'] = sourceParam
            }

            if (this.inviteId) {
              val.data['inviteId'] = this.inviteId
            }
            val.data.sigupJson = JSON.stringify(val.data)

            params.push(val.data)

            if (val.temp) {
              val.temp.forEach((item, index) => {
                Object.keys(curInfoArray).forEach(key => {
                  item[key] = curInfoArray[key]
                })
                item['isCaptain'] = 0

                if (item.countryCode) {
                  const countryKL = item.countryCode
                  item['countryCode'] = countryKL.key
                  item['countryName'] = countryKL.label
                }

                if (item.cityCode) {
                  const cityKL = item.cityCode
                  item['cityCode'] = cityKL.key
                  item['cityName'] = cityKL.label
                } else {
                  item['cityCode'] = ''
                  item['cityName'] = ''
                }

                // item['teamName'] = val.data['teamName']
                item['teamType'] = val.data['teamType']
                item['leaderName'] = val.data['leaderName']
                item['teamName'] = val.data['teamName']
                if (sourceParam) {
                  item['inviteCode'] = sourceParam
                }
                item.sigupJson = JSON.stringify(item)

                params.push(item)
              })
            }

            // console.log(params)

            if (!err) {
              this.subSignInfo = false
              competitionSub(params).then(res => {
                this.subSignInfo = true
                if (res.success) {
                  this.$emit('itemclick', num, this.curInfoArray) // itemclick  为事件名
                  this.$emit('update:formsign', false)
                  if (window._oafs) {
                    window._oafs.action('报名成功', {
                      comId: params[0].competitionId
                    })
                  }
                } else {
                  if (res.code == '403') {
                    message.error(res.message)
                  }
                }
              })
            }
          })
        }
      } else {
        // 自定义事件，把num传给父组件,发射事件
        this.$emit('itemclick', num) // itemclick  为事件名
        this.$emit('update:formsign', false)
      }
    },

    closePop() {
      this.$emit('update:formsign', false)
    },

    targetXuzhi() {
      this.teamType = ''
      this.fileList = []
      this.showXuzhi = !this.showXuzhi

      if (this.showXuzhi && this.xuzhiCont == '') {
        const params = 'id=1705132838718054401'
        getArticleDetail(params).then(res => {
          if (res.success) {
            this.xuzhiCont = res.result
          }
        })
      }
    },

    validateNumber(rule, value, callback) {
      const regMail = new RegExp('^([a-zA-Z0-9._%-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}(\.[a-zA-Z]{2,6})?)$')
      if (value != '' && value != undefined && !regMail.test(value)) {
        callback(new Error(this.globalDataArray.siteTemplateLanguage.mail_format_error))
      } else {
        callback()
      }
    },
    // 验证输入的字符串是否符合中国的身份证号码格式。身份证号码可以是15位或18位数字，其中18位的最后一位可以是数字或字母X（大小写均可）
    validateID(rule, value, callback) {
      const regID = new RegExp(/(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/)
      if (value != '' && value != undefined && !regID.test(value)) {
        callback(new Error('请输入正确的身份证格式 '))
      } else {
        callback()
      }
    },

    validateTwoFactor(rule, value, callback, name, phone) {
      if (!value) {
        callback()
        return
      }
      const params = {
        name: this.form.getFieldValue(name),
        phone: this.form.getFieldValue(phone),
        competitionId: this.curInfoArray.competitionId
      }

      // 这里你可以添加你的二要素验证逻辑
      verifyTwo(params).then(res => {
        if (res.success) {
          const isValid = res.result
          callback()
        } else {
          callback(new Error('手机号未通过二要素验证'))
        }
      })
    },

    beforeUpload(file) {
      if (this.fileList.length > 0) {
        message.error(this.globalDataArray.siteTemplateLanguage.only_upload_one)

        return false
      }

      if (!/\.(?:zip|rar|7z)$/.test(file.name)) {
        message.error(this.globalDataArray.siteTemplateLanguage.file_format_error)

        return false
      }

      if (file.size > 1024 * 1024 * 10) {
        message.error(this.globalDataArray.siteTemplateLanguage.file_size_error)

        return false
      }

      this.fileList.push(file)

      return true
    },

    async customUpload(e) {
      const formData = new FormData()

      formData.append('file', e.file)

      this.uploading = true

      const { success, result, message } = await uploadFile(formData)

      this.uploading = false

      if (success) {
        e.onSuccess(result, e)
      }
      else {
        e.onError(message)
      }
    },

    removeFiles() {
      this.fileList = []
    },

    normFile(e) {
      return (e && e.fileList?.[0]?.response) ?? ''
    },

    onChangeTeamType(e) {
      this.removeFiles()
      this.teamType = e.target.value
    },

    async getCollegeList() {
      const { success, result, message } = await getCollegeList()

      if (success) {
        this.collegeList = result
      }
    },

    searchCollege(value) {
      if (!value) {
        return
      }

      this.filterdCollegeList = this.collegeList.filter(item => {
        if (item.name.indexOf(value) > -1) {
          return true
        }
        return false
      })
    },

    searchCollege1(value, k) {
      console.log(value, k)
      const filteredList = this.collegeList.filter(item => {
        return item.name.indexOf(value) > -1
      })
      // this.temp[k].filterdCollegeList = filteredList
      // this.$set(this.temp[k], 'filterdCollegeList', filteredList)
      // 假设 existingElement 是 temp 数组中已有的元素
      const existingElement = this.temp[k]

      // 使用 $set 方法更新 temp 数组中的元素，并保留原有属性，只更新 filterdCollegeList
      this.$set(this.temp, k, {
        ...existingElement, // 保留原有属性
        filterdCollegeList: filteredList // 更新 filterdCollegeList 属性
      })

      console.log(this.temp[k].filterdCollegeList, 'ooooooooo')
    },

    onChangeCompanyType() {
      this.form.setFieldsValue({
        'data.company': ''
      })
    },

    onChangeCompanyTypeForTeam(k) {
      this.form.setFieldsValue({
        [`temp[${k}].company`]: ''
      })
    },

    // 切换团队类型
    onChangeFieldType(e) {
      console.log(e)
      const newValue = e.target.value === '02' ? '1' : '0'
      this.columnList.forEach(item => {
        if (item.fieldCode === 'fileUrl') {
          item.isShow = newValue
        }
      })
    },

    // 切换单位类型
    onChangeCompany(e) {
      const newValue = e.target.value !== '02' ? '1' : '0'
      this.showList.forEach(item => {
        if (item.fieldCode === 'company') {
          item.isShow = newValue
          item.isDoubleCheck = e.target.value === '02'
        }
      })
    },

    onChangeCompany1(e, k) {
      const newValue = e.target.value !== '02' ? '1' : '0'
      this.temp[k].columnList.forEach(item => {
        if (item.fieldCode === 'company') {
          item.isShow = newValue
          item.isDoubleCheck = e.target.value === '02'
        }
      })
    },

    // 删除上传文件
    removeFiles1(e, item) {
      item.fileList = []
    },

    beforeUpload1(file, item) {
      if (item.fileList.length > 0) {
        message.error(this.globalDataArray.siteTemplateLanguage.only_upload_one)
        return false
      }
      if (!/\.(?:zip|rar|7z)$/.test(file.name)) {
        message.error(this.globalDataArray.siteTemplateLanguage.file_format_error)

        return false
      }
      if (file.size > 1024 * 1024 * 10) {
        message.error(this.globalDataArray.siteTemplateLanguage.file_size_error)

        return false
      }
      item.fileList.push(file)
      return true
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep .upload_new {
  position: relative;
}
</style>
